<template>
  <div>
    <b-modal
      :model-value="modEditaReporte"
      :no-close-on-backdrop="true"
      hide-footer
      centered
      :title="labels.title"
      header-class="reset-modal-header"
      title-class="reset-modal-title"
      body-class="reset-modal-body"
      class="reset-password-dialog edit-reporte-dialog"
      @hide="closeModal"
    >
      <div class="uniform-modal-body">
        <div class="password-policy-box mb-4">
          <div class="password-policy-title">{{ labels.infoTitle }}</div>
          <div class="password-policy-subtitle">{{ labels.infoText }}</div>
        </div>

        <b-row class="d-flex align-items-center uniform-form-row">
          <b-col cols="12" md="4" class="text-left uniform-label-col">
            <h5 class="form-label">{{ labels.codigo }}</h5>
          </b-col>
          <b-col cols="12" md="8" class="text-left">
            <h5 class="mt-1 field-display">{{ ItemReport?.codigo }}</h5>
          </b-col>
        </b-row>

        <b-row class="d-flex align-items-center uniform-form-row">
          <b-col cols="12" md="4" class="text-left uniform-label-col">
            <h5 class="form-label">{{ labels.nombre }}</h5>
          </b-col>
          <b-col cols="12" md="8" class="text-left">
            <b-form-input 
              v-model="ItemReport.nombre" 
              type="text" 
              class="form-input" 
              autocomplete="off"
              :placeholder="labels.nombrePlaceholder"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="d-flex align-items-center uniform-form-row">
          <b-col cols="12" md="4" class="text-left uniform-label-col">
            <h5 class="form-label">{{ labels.principal }}</h5>
          </b-col>
          <b-col cols="12" md="8" class="text-left">
            <b-form-select 
              v-model="ItemReport.principal" 
              class="form-input"
            >
              <b-form-select-option :value="ItemReport?.principal" disabled>
                {{ ItemReport?.principal == true ? labels.yes : labels.not }}
              </b-form-select-option>
              <b-form-select-option value="1">{{ labels.yes }}</b-form-select-option>
              <b-form-select-option value="0">{{ labels.not }}</b-form-select-option>
            </b-form-select>
          </b-col>
        </b-row>

        <b-row class="d-flex align-items-center uniform-form-row">
          <b-col cols="12" md="4" class="text-left uniform-label-col">
            <h5 class="form-label">{{ labels.libro_notas }}</h5>
          </b-col>
          <b-col cols="12" md="8" class="text-left">
            <b-form-input 
              v-model="ItemReport.libro_notas" 
              type="text" 
              class="form-input" 
              autocomplete="off"
              :placeholder="labels.libroNotasPlaceholder"
            ></b-form-input>
          </b-col>
        </b-row>

        <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
          <b-button class="mr-2 reset-btn-secondary" @click="closeModal()">
            {{ labels.cerrar }}
          </b-button>
          <b-button class="reset-btn-primary" @click="editaReporte()">
            {{ labels.guardar }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TipoReporte from '../../../services/TipoReporte'

export default {
  name: 'EditaReporte',
  props: ['modEditaReporte', 'ItemReport'],
  computed: {
    labels() {
      const isEs = this.$store.state._language == "es-ES"
      return {
        title: isEs ? 'Editar Reporte' : 'Edit Report',
        codigo: isEs ? 'Código' : 'Code',
        nombre: isEs ? 'Nombre' : 'Name',
        principal: isEs ? 'Principal' : 'Principal',
        libro_notas: isEs ? 'Libro Notas' : 'Notes',
        yes: isEs ? 'SI' : 'YES',
        not: isEs ? 'NO' : 'NO',
        guardar: isEs ? 'Guardar' : 'Save',
        cerrar: isEs ? 'Cerrar' : 'Close',
        infoTitle: isEs ? 'Datos del reporte' : 'Report information',
        infoText: isEs ? 'Actualiza la información y guarda los cambios.' : 'Update the information and save changes.',
        nombrePlaceholder: isEs ? 'Nombre del reporte' : 'Report name',
        libroNotasPlaceholder: isEs ? 'Libro de notas' : 'Notes book'
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal', false)
    },
    editaReporte() {
      if (this.ItemReport.nombre == '') {
        this.$toast.error('Campo(s) pendiente(s) por diligenciar')
        return
      }

      this.ItemReport.userModifica = this.$store.state.userId || 1

      TipoReporte.updateReporte(this.ItemReport)
        .then((res) => {
          this.$toast.success(res.data.message || 'Reporte actualizado exitosamente')
          this.$emit('refrescaTbl')
          this.closeModal()
        })
        .catch((error) => {
          console.error(error)
          this.$toast.error(error.response?.data?.message || 'No se pudo actualizar el reporte')
        })
    }
  }
}
</script>

<style scoped>
.field-display {
  padding-top: 6px;
  margin-bottom: 0;
}
</style>